import styled from "@emotion/styled/macro";
import { VaultListTagWrapper, VaultTagEllipsis } from "../VaultListTags/VaultListTags.styles";
import { views } from "../../../../common/styles/theme.styles";

export const VaultListItemWrapper = styled.div`
    display: flex;
    height: 56px;
    padding: 8px 8px 8px 0px;
    align-items: center;
    gap: 8px;
    align-self: stretch;

    border-radius: 12px;
    background: #FFF;

    color: var(--Dark-Gray-1, #1A1B1D);
    font-size: 14px;
    font-style: normal;
    font-weight: 450;
    line-height: 130%; /* 18.2px */

    ${({ isSelected }) => isSelected && `
        background: var(--Main-Colors-Light-Grey-1, #F7F8F9);
    `}
    
    &:hover {
        background: var(--Main-Colors-Light-Grey-1, #F7F8F9);
        cursor: pointer;

        ${VaultListTagWrapper} {
            display: flex;
            background: #E9EAEB;
            font-size: 12px;
            font-weight: 450;
        }

        ${VaultTagEllipsis} {
            display: flex;
            background: #E9EAEB;
            font-size: 12px;
            font-weight: 450;
        }
    }
    
    ${views.tablet} {
        .asset-vault-tab-wrapper & [data-checkbox] {
            display: none;
        }
    }
`;

export const VaultListItemTitleWrapper = styled.div`
    display: flex;
    padding: 7px 8px 7px 0;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    flex: 1; 
    min-width: 0;
`;

export const VaultListItemTitleWrapperText = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
`;

export const VaultListItemDataWrapper = styled.div`
    display: flex;
    padding: 7px 0px;
    justify-content: flex-end;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
    align-self: stretch;

    font-size: 12px;
    line-height: normal;
`;

export const VaultListItemHoverDataItemWrapper = styled.div`
    display: flex;
    flex: 1;
`;

export const VaultListItemDataItem = styled.div`
    display: flex;
    flex: 1;
`;

export const VaultListItemOptionsIconWrapper = styled.div`
   display: flex;
    width: 32px;
    height: 32px;
    padding: 8px;
    justify-content: center;
    align-items: center;

    border-radius: 28px;
    cursor: pointer;
`;